import React, { Component, Fragment } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { PieChart, Pie, Cell } from "recharts";

import { Metric, selectFormat } from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

const COLORS = ["#FAA461", "#f4f4f4"];

class WatchingSummaryLive extends Component {
  render() {
    const { data, url } = this.props;

    const firstPiePosition =
      (data.watcher_types && data.watcher_types.power_watchers[0].value / 100) *
      360;
    const secondPiePosition =
      (data.watcher_types && data.watcher_types.power_watchers[0].value / 100) *
        360 +
      90;
    const thirdPiePosition =
      secondPiePosition +
      (data.watcher_types &&
        data.watcher_types.regular_watchers[0].value / 100) *
        360;
    const fourthPiePosition =
      thirdPiePosition +
      (data.watcher_types &&
        data.watcher_types.occasional_watchers[0].value / 100) *
        360;

    return (
      <Fragment>
        {url.includes("g=all") && (
          <Heading size={6} className="mt-n3 mb-4">
            Platform and Region filters will apply to all the widgets below the
            summary.
          </Heading>
        )}

        <div className="row mt-2 d-flex align-items-end">
          <div className="col-6 col-md-3 mb-3 mb-md-4">
            <Heading size={6} className="mb-1">
              UVs Yesterday
            </Heading>
            <Metric {...data.unique_viewers} size="md" />
          </div>

          <div className="col-6 col-md-3 mb-3 mb-md-4">
            <Heading size={6} className={"mb-1"}>
              Video Views Yesterday
            </Heading>
            <Metric {...data.views} size={"md"} />
          </div>

          <div className="col-6 col-md-3 mb-3 mb-md-4">
            <Heading size={6} className={"mb-1"}>
              Minutes Watched Yesterday
            </Heading>
            <Metric {...data.minutes_watched} size={"md"} />
          </div>

          <div className="col-6 col-md-3 mb-md-4">
            <Heading size={6} className={"mb-1"}>
              AVG Mins Per Viewer Yesterday
            </Heading>
            <Metric {...data.avg_mins_per_viewer} size={"md"} />
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12 col-md-3 mb-5 mr-0 mr-mb-4">
            <Heading size={6} className={"mb-1"}>
              Total Entitlements Yesterday
            </Heading>
            <Metric {...data.total_entitlements} size={"md"} />
          </div>

          {data.watcher_types && (
            <>
              <div className="col-6 col-sm-6 col-md-2 d-flex flex-column align-items-center">
                <Heading size={6} className={"mb-1"}>
                  Power Watchers{" "}
                  <div
                    className="with-tooltip"
                    data-tooltip-id="watching-summary-tooltip"
                    data-tooltip-html="30+ Starts in the last 30 days"
                  />
                </Heading>
                <PieChart height={70} width={70}>
                  <Pie
                    dataKey="value"
                    data={data.watcher_types.power_watchers}
                    outerRadius="100%"
                    innerRadius="70%"
                    startAngle={90}
                    endAngle={360 + firstPiePosition + 90}
                  >
                    {data.watcher_types.power_watchers.map((entry, index) => (
                      <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                    ))}
                  </Pie>
                  <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    className="piechart-metric__small"
                  >
                    {selectFormat(
                      "percentage",
                      data.watcher_types.power_watchers[0].value / 100,
                      "%"
                    )}
                  </text>
                </PieChart>
              </div>

              <div className="col-6 col-sm-6 col-md-2 d-flex flex-column align-items-center">
                <Heading size={6} className={"mb-1"}>
                  Regular Watchers
                  <div
                    className="with-tooltip"
                    data-tooltip-id="watching-summary-tooltip"
                    data-tooltip-html="10-29 Starts in the last 30 days"
                  />
                </Heading>
                <PieChart height={70} width={70}>
                  <Pie
                    dataKey="value"
                    data={data.watcher_types.regular_watchers}
                    outerRadius="100%"
                    innerRadius="70%"
                    startAngle={secondPiePosition}
                    endAngle={360 + secondPiePosition}
                  >
                    {data.watcher_types.regular_watchers.map((entry, index) => (
                      <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                    ))}
                  </Pie>
                  <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    className="piechart-metric__small"
                  >
                    {selectFormat(
                      "percentage",
                      data.watcher_types.regular_watchers[0].value / 100,
                      "%"
                    )}
                  </text>
                </PieChart>
              </div>

              <div className="col-6 col-sm-6 col-md-2 d-flex flex-column align-items-center">
                <Heading size={6} className={"mb-1"}>
                  Occasional Watchers
                  <div
                    className="with-tooltip"
                    data-tooltip-id="watching-summary-tooltip"
                    data-tooltip-html="< 10 Starts in the last 30 days"
                  />
                </Heading>
                <PieChart height={70} width={70}>
                  <Pie
                    dataKey="value"
                    data={data.watcher_types.occasional_watchers}
                    outerRadius="100%"
                    innerRadius="70%"
                    startAngle={thirdPiePosition}
                    endAngle={360 + thirdPiePosition}
                  >
                    {data.watcher_types.occasional_watchers.map(
                      (entry, index) => (
                        <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                      )
                    )}
                  </Pie>
                  <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    className="piechart-metric__small"
                  >
                    {selectFormat(
                      "percentage",
                      data.watcher_types.occasional_watchers[0].value / 100,
                      "%"
                    )}
                  </text>
                </PieChart>
              </div>
              <div className="col-6 col-sm-6 col-md-2 d-flex flex-column align-items-center">
                <Heading size={6} className={"mb-1"}>
                  Non Watchers
                  <div
                    className="with-tooltip"
                    data-tooltip-id="watching-summary-tooltip"
                    data-tooltip-html="0 Starts in the last 30 days."
                  />
                </Heading>
                <PieChart height={70} width={70}>
                  <Pie
                    dataKey="value"
                    data={data.watcher_types.non_watchers}
                    outerRadius="100%"
                    innerRadius="70%"
                    startAngle={fourthPiePosition}
                    endAngle={360 + fourthPiePosition}
                  >
                    {data.watcher_types.non_watchers.map((entry, index) => (
                      <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                    ))}
                  </Pie>
                  <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    className="piechart-metric__small"
                  >
                    {selectFormat(
                      "percentage",
                      data.watcher_types.non_watchers[0].value / 100,
                      "%"
                    )}
                  </text>
                </PieChart>
              </div>
            </>
          )}
          <ReactTooltip
            id="watching-summary-tooltip"
            className="title-tooltip"
          />

          {/* <div className="col-auto d-flex flex-column align-items-center mr-3">
            <h6 className="widget__metric-label">Never Watchers</h6>
            <PieChart height={70} width={70}>
              <Pie dataKey="value" data={data.pie_charts.never_watchers} outerRadius="100%" innerRadius="70%">
                {
                  data.pie_charts.never_watchers.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                  ))
                }
              </Pie>
              <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="piechart-metric__small">
                {selectFormat('percentage', data.pie_charts.never_watchers[1].value / 100, '%')}
              </text>
            </PieChart>
          </div> */}
        </div>
      </Fragment>
    );
  }
}

export default WatchingSummaryLive;
